import { Application } from "Application";
import * as Constants from "Data/Constants";
import { Linear, Sine } from "gsap/EasePack";
import { TimelineLite } from "gsap/TimelineLite";
import { TweenMax } from "gsap/TweenMaxBase";
import * as HLF from "html-living-framework";

import type {Animation} from "gsap";
export class Interstitial extends HLF.LoadScreen {
    private _bg!: PIXI.Sprite;
    private _spinner!: PIXI.Sprite;
    private _text!: PIXI.extras.BitmapText;
    private _loop: Animation | undefined;

    public init(pSize: PIXI.Point) {
        super.init(pSize);

        if (this._bg === undefined) {
            this._bg = HLF.PixiUtils.makeSprite("loader-background");
        }
        if (this._text === undefined) {
            this._text = HLF.PixiUtils.makeText("Loading...", Constants.FONT_GEL_MED_35, 35, HLF.Colour.WHITE.toHex());
        }
        if (this._spinner === undefined) {
            this._spinner = HLF.PixiUtils.makeSprite("loader", Constants.SPRITESHEET_UI);
        }

        this._bg.interactive = true;
        this._bg.alpha = 0;
        // this._bg.scale.set(this._size.x, this._size.y);

        this._text.anchor = new PIXI.Point(0.5, 1);
        this._text.alpha = 0;
        this._text.position.set(0, this._size.y / 2);

        this.addChild(this._bg);
        this.addChild(this._text);
        this.addChild(this._spinner);
    }

    public animateIn(pOnComplete: () => void): void {
        Application.instance.voiceover.stopVO();
        PubSub.publishSync(HLF.STOP_CAPTION, undefined);

        // console.log("show spinner");
        this._bg.alpha = 0;
        const timeline: TimelineLite = new TimelineLite();
        timeline.to([this._bg, this._text, this._spinner], 1.0, {
            alpha: 1,
            ease: Sine.easeInOut,
        });
        timeline.call(pOnComplete);
        this._loop = TweenMax.fromTo(this._spinner, 0.75,
            {pixi: {rotation: 0}},
            {pixi: {rotation: -360}, ease: Linear.easeNone},
        ).repeat(-1);
    }

    public animateOut(pOnComplete: () => void): void {
        // console.log("hide spinner");
        const timeline: TimelineLite = new TimelineLite();
        timeline.to([this._bg, this._text, this._spinner], 1.0, {
            alpha: 0,
            ease: Sine.easeInOut,
        });
        timeline.call(() => {
            if (this._loop !== undefined) {
                this._loop.kill();
            }
        });
        timeline.call(pOnComplete);
    }

    public onLoadComplete(pCallback: () => void): void {
        if (Application.instance.paused) {
            const _cb = () => {
                PubSub.unsubscribe(_cb);
                pCallback();
            };
            PubSub.subscribe(HLF.GAME_UNPAUSED, _cb);
        }
        else {
            pCallback();
        }
    }

    public onResize(pSize: PIXI.Point) {
        super.onResize(pSize);

        if (this._bg !== undefined) {
            // this._bg.scale.set(this._size.x, this._size.y);
        }

        if (this._text !== undefined) {
            this._text.position.set(0, this._size.y / 2);
        }
    }
}
